import type { ConstructorValue } from '../../features/design-constructor';
import type { Template } from './types';

const KEY = 'game-platform.design-system';

export interface PersistedTheme {
  template: Template;
  value: ConstructorValue;
}

export function saveDesignSystem(persisted: PersistedTheme): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(persisted));
  } catch {
    // Ignore quota / disabled storage errors silently.
  }
}

export function loadDesignSystem(): PersistedTheme | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (
      !parsed ||
      typeof parsed !== 'object' ||
      !('template' in parsed) ||
      !('value' in parsed)
    ) {
      return null;
    }
    return parsed as PersistedTheme;
  } catch {
    return null;
  }
}

export function clearDesignSystem(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Ignore.
  }
}
